import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'categoryIconSrc', })
export class CategoryIconSrcPipe implements PipeTransform {
  transform(category: string): string {
    category = category.toLowerCase();

    return `/assets/icons/products/icon-${category}.svg`;
  }
}
